<!-- **
  * 显示样式参考 空调系统能效界面
* -->
<template>
    <div v-if="listData.length > 0" :class="classObject">
        <template v-if="together">
            <div :class="activeTitle?.activeModal === modalName && activeTitle?.activeIndex == -1 ? 'together isActive' : 'together'"
                @click="changeBtn(-1)">
                <div v-for="(v, i) in listData" :key="i" :style="{ width: listData.length === 1 ? '100%' : '' }">
                    <div class="firstDiv">
                        <div v-if="v?.rateFlag">
                            <span>{{ `${v?.name}/${v?.nameTotal}` }}</span>
                        </div>
                        <div v-else>
                            <span>{{ v?.name }}</span>
                        </div>
                    </div>
                    <div v-if="v?.details" class="secondDiv">
                        <TitleTipsItem :listData="v?.details || []" className="headTipsBtnItem" />
                    </div>
                    <div class="thirdDiv">
                        <div v-if="v?.rateFlag">
                            <span :title=v?.value class="highlight">{{ dealBigNum(v?.value) }}</span>
                            <span :title=v?.valueTotal class="bold">/{{ dealBigNum(v?.valueTotal) }}</span>
                            <!-- {{ `${v.value}/${v.valueTotal}` }} -->
                        </div>
                        <div v-else>
                            <span :title=v?.value class="highlight">{{ dealBigNum(v?.value) }}</span>
                            <span v-if="!!v?.unit">{{ v?.unit }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div v-for="(v, i) in listData" :key="i"
                :class="activeTitle?.activeModal === modalName && activeTitle?.activeIndex == i ? 'single isActive' : 'single'"
                :style="{ width: listData.length === 1 ? '100%' : '' }" @click="changeBtn(i)">
                <div class="firstDiv">
                    <div v-if="v?.rateFlag">
                        <span>{{ `${v?.name}/${v?.nameTotal}` }}</span>
                    </div>
                    <div v-else>
                        <span>{{ v?.name }}</span>
                    </div>
                </div>
                <div v-if="v?.details" class="secondDiv">
                    <TitleTipsItem :listData="v?.details || []" className="headTipsBtnItem" />
                </div>
                <div class="thirdDiv">
                    <div v-if="v?.rateFlag">
                        <span :title=v?.value class="highlight">{{ dealBigNum(v?.value) }}</span>
                        <span :title=v?.valueTotal class="bold">/{{ dealBigNum(v?.valueTotal) }}</span>
                        <!-- {{ `${v.value}/${v.valueTotal}` }} -->
                    </div>
                    <div v-else>
                        <span :title=v?.value class="highlight">{{ dealBigNum(v?.value) }}</span>
                        <span v-if="!!v?.unit">{{ v?.unit }}</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
  
<script>
const classNames = require('classnames')
import { dealBigNum } from "@/assets/js/utils";
import TitleTipsItem from '@/components/TitleTips/TitleTipsItem.vue';
export default {
    components: { TitleTipsItem },
    name: "HeadTipsBtn",
    props: {
        listData: {
            type: Array,
            default: () => []
        },
        twoLine: {
            type: Boolean,
            default: false,
        },
        together: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: ""
        },
        activeTitle: {
            type: Object,
            default: () => { }
        },
        modalName: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            listColor: [
                "#279fff",
                "#29c444",
                "#fecc2b",
                "#7472fc",
                "#279fff",
                "#29c444",
                "#fecc2b",
            ],
        };
    },
    computed: {
        classObject: function () {
            return classNames({
                'headTipsBtn': true,
                'twoLine': this.twoLine,
                [this.className]: !!this.className,
            })
        },
    },
    methods: {
        dealBigNum,
        changeBtn(index) {
            const newActive = {
                activeModal: this.modalName,
                activeIndex: index
            }
            this.$emit("change-title", newActive);
        }
    },
};
</script>
  
<style lang="scss" scoped>
.headTipsBtn {
    width: 100%;
    height: 100%;
    @include setFlexAround;

    .single {
        @include setFlexColumn;
        align-items: center;
        justify-content: center;
        background: #F8FAFB;
        border-radius: 7px;
        border: 1px solid #E4E4E4;
        width: 160px;
        height: 140px;
        flex-direction: column;
        cursor: pointer;

        .firstDiv {
            font-size: 16px;
            font-weight: bold;
        }

        .secondDiv {
            margin-top: 8px;
        }

        .thirdDiv {
            margin-top: 8px;
            font-size: 14px;

            .highlight {
                color: #28CCCB;
                font-weight: bold;
                font-size: 30px;
            }

            .bold {
                color: black;
                font-weight: bold;
                font-size: 26px;
            }
        }
    }

    .together {
        width: 80%;
        margin: auto;
        background: #F8FAFB;
        border-radius: 7px;
        border: 1px solid #E4E4E4;
        height: 140px;
        display: flex;
        cursor: pointer;

        &>div {
            @include setFlexColumn;
            align-items: center;
            justify-content: center;
            width: 160px;
            height: 140px;
            flex-direction: column;

            .firstDiv {
                font-size: 16px;
                font-weight: bold;
            }

            .secondDiv {
                margin-top: 8px;
            }

            .thirdDiv {
                margin-top: 8px;
                font-size: 14px;

                .highlight {
                    color: #28CCCB;
                    font-weight: bold;
                    font-size: 30px;
                }

                .bold {
                    color: black;
                    font-weight: bold;
                    font-size: 26px;
                }
            }
        }
    }

    .isActive {
        border-color: #28CCCB;
    }
}

.twoLine {
    flex-wrap: wrap;

    &>div {
        width: 93px;
        height: 50%;

        .firstDiv {
            font-size: 14px;

            .highlight {
                color: #28CCCB;
                font-weight: bold;
                font-size: 26px;
            }

            .bold {
                color: black;
                font-weight: bold;
                font-size: 22px;
            }
        }

        .secondDiv {}
    }
}

::v-deep .headTipsBtnItem>div .itemName {
    font-weight: 400;
    color: #666;
}
</style>